import React, { useState } from "react";
import { useActivePath } from "../shared/ActivePathContext";
import Brand from "../shared/brand/Brand";
import Nav from "../shared/nav/Nav";
import NavItem from "../shared/navItem/NavItem";
import NavSignoutBar from "../shared/navSignoutBar/NavSignoutBar";
import { BrandHolder, VerticalNavContainer } from "./VerticalNavStyles";
import ComponentBar from "./componentBar/ComponentBar";
import NavMenu from "./navMenu/NavMenu";
import NavBar from "./navbar/Navbar";
const signoutHeight = 20;
const VerticalNavigation = ({ config, children, customLinkComponent }) => {
    const { loggedIn, username, startLogo, endLogo, verticalWidth, navigationLinks = [], usernameDropdownLinks = [], builds = [], env = "prod", displayEnvIndicator = false, displayPermissionsIndicator = false, permissions = undefined, status, zIndex, } = config;
    const [verticalNavWidth, setVerticalNavWidth] = useState(verticalWidth ?? 40);
    const [crossHeight, setCrossHeight] = useState(40);
    const { isActivePath } = useActivePath();
    return (React.createElement(React.Fragment, null,
        loggedIn && (React.createElement(NavSignoutBar, { username: username, links: usernameDropdownLinks, displayEnvIndicator: displayEnvIndicator, displayPermissionsIndicator: displayPermissionsIndicator, permissions: permissions, env: env, isVertical: true })),
        React.createElement(VerticalNavContainer, null,
            React.createElement(ComponentBar, { setHeight: setCrossHeight, top: signoutHeight },
                React.createElement("div", { className: "d-flex" },
                    React.createElement(BrandHolder, null, !!startLogo?.visible && (React.createElement(Brand, { logo: startLogo.logo, link: startLogo.link, text: startLogo.text, contentHeight: startLogo.logoHeight, builds: builds, customLinkComponent: customLinkComponent, isVertical: true }))),
                    children)),
            React.createElement(NavBar, { top: crossHeight + signoutHeight, fixedWidth: verticalWidth, setWidth: setVerticalNavWidth, zIndex: zIndex },
                loggedIn && !!navigationLinks?.length && (React.createElement(Nav, { direction: "column", width: verticalWidth ? verticalWidth + "px" : undefined }, navigationLinks.map((link) => {
                    if (link.visible !== false) {
                        if (!!link.subLinks?.length) {
                            return (React.createElement(NavMenu, { ...link, key: link.name, verticalNavWidth: verticalNavWidth, customLinkComponent: customLinkComponent }));
                        }
                        else {
                            return (React.createElement(NavItem, { ...link, active: isActivePath(link), isVertical: true, key: link.name, customLinkComponent: customLinkComponent }));
                        }
                    }
                    else {
                        return null;
                    }
                }))),
                !!endLogo?.visible && (React.createElement(Nav, { align: "center", className: "mt-auto mb-2" },
                    React.createElement(Brand, { logo: endLogo.logo, link: endLogo.link, text: endLogo.text, contentHeight: endLogo.logoHeight, customLinkComponent: customLinkComponent, isVertical: true })))))));
};
export default VerticalNavigation;
//# sourceMappingURL=VerticalNavigation.js.map